import React, { useEffect, useState } from 'react';
import * as api from '../../api';
import MRRequestTable from './MRRequestTable';

export default function MRMyRequests({ onOpen }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.getMe().then(me =>
      api.listMaterialRequests({ requested_by_id: me.user_id, limit: 50 })
    ).then(r => {
      setRows(r?.items || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 style={{ margin: '0 0 16px', fontWeight: 700, fontSize: 18 }}>My Requests</h2>
      <MRRequestTable rows={rows} loading={loading} onOpen={onOpen} emptyMsg="You have no material requests yet." />
    </div>
  );
}
